module.exports = __webpack_public_path__ + "static/media/wait.016044ea.png";